import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { useMatch } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import childrenShape from 'react/shared/shapes/children';
import theme, { mediumBreakpointMediaQuery } from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import { MODULES } from 'react/signups/card/recipes/constants';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import userTypeShape from 'react/signups/card/shapes/UserType';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
  sidebar: {
    [theme.breakpoints.up('md')]: {
      background: PALETTE.white,
      width: '325px',
    },
  },
  content: {
    '&.MuiGrid-root': {
      [theme.breakpoints.up('md')]: {
        marginBottom: '72px',
        marginTop: '72px',
        marginLeft: '36px',
        marginRight: 0,
        maxWidth: `${theme.breakpoints.values.cd}px`,
      },
    },
  },
}));

export default function ModuleLayout({
  cardholderFirstName,
  children,
  currentModule = MODULES.SURVEY,
  userType,
}) {
  const classes = useStyles();
  const desktop = useMediaQuery(mediumBreakpointMediaQuery);
  const isSuccessPage = useMatch('/review/success');
  const showSidebar = desktop && userType && MODULES.SURVEY !== currentModule && !isSuccessPage;

  return (
    <Grid container direction="column">
      <Grid container item>
        {showSidebar ? (
          <Grid className={classes.sidebar} item>
            <Sidebar
              cardholderFirstName={cardholderFirstName}
              currentModule={currentModule}
              userType={userType}
            />
          </Grid>
        ) : (
          <Grid className={classes.fullWidth} item>
            <TopBar
              cardholderFirstName={cardholderFirstName}
              currentModule={currentModule}
              userType={userType}
            />
          </Grid>
        )}
        <Grid className={showSidebar ? classes.content : classes.fullWidth} item>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
}

ModuleLayout.propTypes = {
  cardholderFirstName: PropTypes.string,
  children: childrenShape.isRequired,
  currentModule: currentModuleShape,
  userType: userTypeShape,
};
